export const UNIVERSAL_RESOLVER_ADDRESS =
  "0xce01f8eee7E479C928F8919abD53E553a36CeF67";
export const BASENAME_RESOLVER_ADDRESS =
  "0xC6d566A56A1aFf6508b41f6c90ff131615583BCD";
export const BASE_SEPOLIA_BASENAME_RESOLVER_ADDRESS =
  "0x6533C94869D28fAA8dF77cc63f9e2b2D6Cf77eBA";
